import { useTranslation } from "react-i18next";
import { AppDatePicker } from "../../../../../../shared/components/AppDatePicker";
import styles from "./styles.module.css";
import { useState } from "react";
import { BotObject } from "../../../../../../services/api/instances/botApi/types";

interface Props {
  bot: BotObject;
  className?: string;
}

export const ChatDatePicker = ({ bot }: Props) => {
  const [dateWarning, setDateWarning] = useState(false);
  const { t } = useTranslation();

  const handleDateChange = (
    date: Date | null,
    type: "dateStart" | "dateEnd",
  ) => {
    const oldItem = { ...bot };
    if (!oldItem.dateStart || !oldItem.dateEnd) return;
    oldItem[type] = date;

    if (
      (type === "dateStart" && date && bot.dateEnd && date > bot.dateEnd) ||
      (type === "dateEnd" && date && bot.dateStart && date < bot.dateStart)
    ) {
      setDateWarning(true);
    } else {
      setDateWarning(false);
    }
  };

  const parseToDate = (date: string) => new Date(date);

  return (
    <div>
      <div className={styles["date-container"]}>
        <span className={styles["date-label"]}>{t("chatbot.period_from")}</span>
        <AppDatePicker
          value={parseToDate(bot.dateStart as string)}
          onChange={(date) => handleDateChange(date, "dateStart")}
        />
        <span className={styles["date-label"]}>{t("chatbot.period_to")}</span>
        <AppDatePicker
          value={parseToDate(bot.dateEnd as string)}
          onChange={(date) => handleDateChange(date, "dateEnd")}
        />
      </div>
      {dateWarning && (
        <p className={styles["date-warning"]}>
          {t("chatbot.warn_message_range")}
        </p>
      )}
    </div>
  );
};
